import { Link } from 'react-router-dom';

// material-ui
import { Box, Card, CardMedia, Grid, Stack, Typography } from '@mui/material';

// project import
// import useAuth from 'hooks/useAuth';
import AuthWrapper from 'sections/auth/AuthWrapper';
import AuthLogin from 'sections/auth/auth-forms/AuthLogin';
import useMain from 'hooks/useMain';
import { useEffect } from 'react';
import { isUserLoggedIn, useLocalStorage, versionCheckAndRefresh } from 'utils/common';
import { sessionConfig } from 'utils/constant';
import FullLogoIcon from 'assets/images/logo/logo_full.png';

// ================================|| LOGIN ||================================ //

const Login = () => {
  const { useNavigate, useLocation } = useMain();
  const navigate = useNavigate();
  const location = useLocation();
  const { setStorage } = useLocalStorage();

  useEffect(() => {
    const loginData = location.search.replace('?', '');

    if (loginData) {
      const loginToken = loginData.split('&')[0].replace('token=', '');
      const fullName = loginData.split('&')[1].replace('fullName=', '');
      const role = loginData.split('&')[2].replace('role=', '');
      if (loginToken) {
        setStorage(sessionConfig.storageRefreshTokenKeyName, loginToken);
        setStorage(sessionConfig.storageTokenKeyName, loginToken);
        setStorage(sessionConfig.userData, { fullName, role, navigate: '/functions/realtimeMapGps' });
      }
      if (loginToken && fullName && role) {
        navigate('/product');

        return;
      }
    }

    if (isUserLoggedIn()) {
      navigate('/product');
      return;
    }
    if (location.pathname === '/') {
      navigate('/login');
      return;
    }
  }, [location.pathname]);

  useEffect(() => {
    versionCheckAndRefresh();
  }, []);

  return (
    <AuthWrapper>
      <Grid container>
        <Grid item xs={12}>
          <Stack direction="row" justifyContent="center" alignItems="baseline" sx={{ mb: { xs: -0.5, sm: 0.5 } }}>
            <img src={FullLogoIcon} alt="rfid-logo" style={{ maxHeight: '100px' }} />
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <AuthLogin />
        </Grid>
      </Grid>
    </AuthWrapper>
  );
};

export default Login;
